/**
 * Vertiefungs-Bausteine der Referenzseiten (sections/reference-case.liquid, Blöcke):
 * Kurvenschalter der Messkurven und Wiedergabe des Hörbeispiels.
 * Das Raummodell hat ein eigenes Skript je Modell (assets/raummodell-raum33.js).
 * Ohne JavaScript bleiben Diagramm, Tabelle und Texte vollständig lesbar.
 */
(() => {
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];

  // Bedienelemente, die nur mit JavaScript funktionieren, stehen im Markup auf hidden.
  $$('.ref-vt [data-rv-js]').forEach((el) => {
    el.hidden = false;
  });

  /* ── Messkurven: Reihen ein- und ausblenden ── */
  $$('[data-ref-kurven]').forEach((block) => {
    $$('[data-rv-serie-schalter]', block).forEach((button) => {
      button.addEventListener('click', () => {
        const an = button.getAttribute('aria-pressed') !== 'true';
        button.setAttribute('aria-pressed', String(an));
        $$(`[data-rv-serie="${button.dataset.rvSerieSchalter}"]`, block).forEach((serie) => {
          serie.classList.toggle('is-aus', !an);
        });
      });
    });
  });

  /* ── Hörbeispiel ── */
  $$('[data-rv-audio]').forEach((player) => {
    const status = player.querySelector('[data-rv-audio-status]');
    const clips = $$('[data-rv-clip]', player);
    const knoepfe = $$('[data-rv-play]', player);
    let aktiv = null;
    const melden = (text) => {
      if (status) status.textContent = text;
    };
    const stopp = () => {
      clips.forEach((clip) => {
        clip.pause();
        clip.currentTime = 0;
      });
      knoepfe.forEach((b) => {
        b.setAttribute('aria-pressed', 'false');
      });
      player.classList.remove('is-playing');
      aktiv = null;
    };
    knoepfe.forEach((button) => {
      button.addEventListener('click', async () => {
        const id = button.dataset.rvPlay;
        const warAktiv = aktiv === id;
        stopp();
        if (warAktiv) {
          melden('Wiedergabe angehalten.');
          return;
        }
        const clip = player.querySelector(`[data-rv-clip="${id}"]`);
        try {
          await clip.play();
          aktiv = id;
          button.setAttribute('aria-pressed', 'true');
          player.classList.add('is-playing');
          melden(`${button.textContent.replace('▶', '').trim()} wird abgespielt.`);
        } catch {
          stopp();
          melden('Die Wiedergabe konnte nicht gestartet werden.');
        }
      });
    });
    clips.forEach((clip) => {
      clip.addEventListener('ended', () => {
        stopp();
        melden('Hörbeispiel beendet.');
      });
    });
    player.querySelector('[data-rv-stop]')?.addEventListener('click', () => {
      stopp();
      melden('Wiedergabe angehalten.');
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden && aktiv) {
        stopp();
        melden('Wiedergabe angehalten.');
      }
    });
  });
})();
